import { NotificationEventEnum } from '.'
import { NotificationEventItem } from './NotificationEventItem'

const Issued = new NotificationEventItem({
  id: '4b3a025e-1c2a-45fa-9018-388d04164a78',
  name: 'Issued',
  description: `An Engineering Judgement is issued`,
})

export type EJNotificationEventItem = typeof Issued

class EJNotificationEnum extends NotificationEventEnum<
  'EJNotification',
  EJNotificationEventItem,
  EJNotificationEventItem['name'],
  EJNotificationEventItem['id']
> {
  typename = 'EJNotification' as const
  get values() {
    return [this.Issued]
  }
  readonly Issued = Issued
}

export const EJNotificationEvent = new EJNotificationEnum()
